// Calendar Navigation Fix Script
document.addEventListener('DOMContentLoaded', function() {
  console.log('Calendar navigation fix script loaded');
  
  // Global calendar state
  let currentDate = new Date();
  let calendarInitialized = false;
  let isObserverWorking = false; // Flag to prevent observer recursion
  
  // Initialize the calendar with the current month
  function initializeCalendar() {
    if (calendarInitialized) return;
    
    const currentMonthHeader = document.getElementById('current-month-display');
    if (!currentMonthHeader) {
      console.error('Cannot find current month display element');
      return;
    }
    
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    // Set the current month display
    currentMonthHeader.textContent = `${months[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    
    // Find and fix nav buttons
    setupNavigationButtons();
    
    calendarInitialized = true;
    console.log('Calendar initialized to', currentMonthHeader.textContent);
  }
  
  // Set up the navigation buttons with proper event listeners
  function setupNavigationButtons() {
    // First find the navigation buttons
    const prevMonthButton = document.getElementById('prev-month');
    const nextMonthButton = document.getElementById('next-month');
    
    if (!prevMonthButton || !nextMonthButton) {
      console.error('Could not find month navigation buttons');
      return;
    }
    
    // Skip if we're already setting up the buttons through the observer
    if (isObserverWorking) {
      console.log('Skipping button setup - observer is active');
      return;
    }
    
    console.log('Found navigation buttons, cleaning up and setting new handlers');
    
    // Set the flag to prevent recursion
    isObserverWorking = true;
    
    try {
      // Remove any existing event listeners by cloning and replacing
      const newPrevButton = prevMonthButton.cloneNode(true);
      const newNextButton = nextMonthButton.cloneNode(true);
      
      prevMonthButton.parentNode.replaceChild(newPrevButton, prevMonthButton);
      nextMonthButton.parentNode.replaceChild(newNextButton, nextMonthButton);
      
      // Add our own event listeners
      newPrevButton.addEventListener('click', handlePrevMonth);
      newNextButton.addEventListener('click', handleNextMonth);
      
      // Add a class to mark these buttons as fixed
      newPrevButton.classList.add('calendar-nav-fixed');
      newNextButton.classList.add('calendar-nav-fixed');
      
      console.log('Navigation buttons set up with new handlers');
    } finally {
      // Clear the flag when done
      isObserverWorking = false;
    }
  }
  
  // Only setup buttons once per element, using a modified approach
  function setupButtonsIfNeeded() {
    const prevMonthButton = document.getElementById('prev-month');
    const nextMonthButton = document.getElementById('next-month');
    
    if (!prevMonthButton || !nextMonthButton) return;
    
    // Only set up if they don't have our special class
    if (!prevMonthButton.classList.contains('calendar-nav-fixed') || 
        !nextMonthButton.classList.contains('calendar-nav-fixed')) {
      setupNavigationButtons();
    }
  }
  
  // Handle previous month navigation
  function handlePrevMonth(e) {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('Prev month button clicked');
    
    // Move to previous month
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() - 1);
    currentDate = newDate;
    
    updateCalendarDisplay();
    
    console.log('Navigated to previous month:', 
               currentDate.toLocaleString('default', { month: 'long', year: 'numeric' }));
  }
  
  // Handle next month navigation
  function handleNextMonth(e) {
    e.preventDefault();
    e.stopPropagation();
    
    console.log('Next month button clicked');
    
    // Move to next month
    const newDate = new Date(currentDate);
    newDate.setMonth(newDate.getMonth() + 1);
    currentDate = newDate;
    
    updateCalendarDisplay();
    
    console.log('Navigated to next month:', 
               currentDate.toLocaleString('default', { month: 'long', year: 'numeric' }));
  }
  
  // Update the calendar display and trigger event refresh
  function updateCalendarDisplay() {
    const currentMonthHeader = document.getElementById('current-month-display');
    if (!currentMonthHeader) {
      console.error('Cannot find current month display element');
      return;
    }
    
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    
    // Update the month display
    currentMonthHeader.textContent = `${months[currentDate.getMonth()]} ${currentDate.getFullYear()}`;
    
    // Trigger a custom event for other scripts to listen for
    const event = new CustomEvent('calendarMonthChanged', {
      detail: {
        year: currentDate.getFullYear(),
        month: currentDate.getMonth(),
        monthName: months[currentDate.getMonth()]
      }
    });
    
    document.dispatchEvent(event);
    
    // If this is in the context of a Shopify store, update global state variables
    if (window.viewMonth !== undefined && window.viewYear !== undefined) {
      // These variables are 1-indexed in the other script
      window.viewMonth = currentDate.getMonth() + 1;
      window.viewYear = currentDate.getFullYear();
      
      // Call updateEventVisibility if it exists
      if (typeof window.updateEventVisibility === 'function') {
        window.updateEventVisibility();
      }
    }
    
    // Force refresh method used by the calendar embed
    if (typeof window.updateCalendar === 'function') {
      window.currentDate = new Date(currentDate);
      window.updateCalendar();
    }
  }
  
  // Initialize the calendar once the page has loaded
  setTimeout(function() {
    initializeCalendar();
    console.log('Delayed calendar initialization complete');
  }, 500);
  
  // Also set up a mutation observer to handle dynamic content loading - limited to avoid infinite loops
  const observer = new MutationObserver(function(mutations) {
    if (isObserverWorking) return;
    
    let shouldSetupButtons = false;
    
    mutations.forEach(function(mutation) {
      if (mutation.addedNodes && mutation.addedNodes.length > 0) {
        // Check if any added nodes are related to our calendar
        for (let i = 0; i < mutation.addedNodes.length; i++) {
          const node = mutation.addedNodes[i];
          if (node.nodeType === 1 && (
              node.id === 'market-events-calendar' || 
              node.classList && node.classList.contains('market-events-calendar') ||
              node.querySelector && (
                node.querySelector('#market-events-calendar') || 
                node.querySelector('.market-events-calendar')
              )
            )) {
            shouldSetupButtons = true;
            break;
          }
        }
      }
    });
    
    if (shouldSetupButtons) {
      console.log('Calendar related content detected - checking for navigation setup');
      setTimeout(setupButtonsIfNeeded, 100);
    }
  });
  
  // Start observing the document body for changes, but with a more specific config
  observer.observe(document.body, { 
    childList: true,
    subtree: true,
    attributes: false,
    characterData: false
  });
  
  // Export functions to global scope for debugging
  window.marketCalendarFix = {
    init: initializeCalendar,
    setupNavButtons: setupButtonsIfNeeded,
    goToPrevMonth: handlePrevMonth,
    goToNextMonth: handleNextMonth
  };
}); 